import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISubtopicMobile } from "../../../Pages/SubtopicMobile/ISubtopicMobile";

export const ListSubtopicMobileSlice = createSlice({
  name: "ListSubtopicMobileSlice",
  initialState: {} as IReduxState<ISubtopicMobile[]>,
  reducers: {
    listSubtopicMobile: (state) => {
      state.isLoading = true;
    },
    successlistSubtopicMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistSubtopicMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistSubtopicMobile,
  listSubtopicMobile,
  successlistSubtopicMobile,
} = ListSubtopicMobileSlice.actions;

export default ListSubtopicMobileSlice.reducer;
